<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center">
      <p>{{ $t('productCategory.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteProductCategory } from '@/api/goods/productCategoryApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteProductCategory',
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        categoryId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteData.categoryId = row.categoryId
      this.deleteData.shopId = getShopId()
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async confirmDelete() {
      try {
        await deleteProductCategory(this.deleteData)
        this.$emit('refresh')
        this.$message.success(this.$t('common.submitSuccess'))
        this.closeDialog()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error)
      }
    }
  }
}
</script>